module.exports = __webpack_public_path__ + "3005fb780d47c33778a22ec7a0ffeba4.png";